import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomFilterProps, Filter, GroupByValue, Option } from './filter';

export const GROUP_BY_FILTER_OPTIONS: Option[] = [
  {
    label: <FormattedMessage id="default" />,
    value: GroupByValue.Default,
  },
  {
    label: <FormattedMessage id="due_date" />,
    value: GroupByValue.DueDate,
  },
  {
    label: <FormattedMessage id="project" />,
    value: GroupByValue.Project,
  },
];
interface GroupByFilterProps extends CustomFilterProps {
  options?: Option[];
}
export const GroupByFilter: FC<GroupByFilterProps> = ({
  onChange,
  options = GROUP_BY_FILTER_OPTIONS,
}) => (
  <Filter
    label={<FormattedMessage id="group_by" />}
    options={options}
    value={GroupByValue.Default}
    onChange={onChange}
  />
);

export const GroupByFilterForCompanyTasks: FC<GroupByFilterProps> = (props) => (
  <Filter
    {...props}
    label={<FormattedMessage id="group_by" />}
    options={GROUP_BY_FILTER_OPTIONS.filter(
      (o) => o.value !== GroupByValue.Default,
    )}
    value={GroupByValue.DueDate}
  />
);
